import type { FC, PropsWithChildren } from 'react';
import { Modal, ModalForm, InputsSection, ModalButtons } from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ToggleModalSkeleton from '../../Skeletons/ToggleModalSkeleton';
import { DeleteModalState } from './DeleteModal';

type ModalProps = PropsWithChildren<{
  loading: boolean;
  toggleModal: DeleteModalState;
  onCloseModal?: () => void;
  handleToggle?: (event: React.FormEvent<HTMLFormElement>) => void;
}>;

const ToggleModal: FC<ModalProps> = props => {
  return (
    <Modal show={props.toggleModal.status}>
      <ModalHeading heading={`${props.toggleModal.data?.isActive ? 'Deactivate' : 'Activate'} ${props.toggleModal.data?.name} `} />
      {props.loading ? (
        <ToggleModalSkeleton />
      ) : (
        props.toggleModal.data && (
          <ModalForm style={{ marginBottom: '2.5rem' }} onSubmit={props.handleToggle}>
            <InputsSection style={{ width: '34rem' }}>
              {props.toggleModal.data.isActive ? (
                <p className='primaryText'>
                  Deactivate {props.toggleModal.data.name} Plan.
                  <br />
                  <br /> <span className='dangerText'>Are you sure you want to proceed?</span>
                </p>
              ) : (
                <p className='primaryText'>
                  Activate {props.toggleModal.data.name} Plan.
                  <br />
                  <br /> <span className='dangerText'>Are you sure you want to proceed?</span>
                </p>
              )}
            </InputsSection>

            <ModalButtons
              submitButtonLabel={props.toggleModal.data?.isActive ? 'Deactivate' : 'Activate '}
              cancelButtonLabel='Cancel'
              onCancel={props.onCloseModal}
            />
          </ModalForm>
        )
      )}
    </Modal>
  );
};

export default ToggleModal;
